/* eslint-disable @typescript-eslint/no-unused-vars */
import { Cache } from "memory-cache";
import { StaticStorageClient } from "../service/staticstorageclient";
import { SolarSystemEntity } from ".";

// Static Storage Client
const dataClient = new StaticStorageClient();

// Cache
const cache = new Cache();

export async function getCachedSolarSystemEntity(solarsystem_id: number): Promise<SolarSystemEntity | null> {
  let entity: any = await cache.get(solarsystem_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const system = await dataClient.get_solarsystem_by_id(solarsystem_id);
    if (system !== null) {
      entity = new SolarSystemEntity(solarsystem_id, system);
      cache.put(solarsystem_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getCachedSolarSystemListBySearchString(searchstring: string, strict: boolean): Promise<any> {
  const list: any = await dataClient.get_solarsystems_by_string(searchstring, strict);
  let entities = [];
  if (list !== null) {
    for (const y of list) {
      entities.push(y.solarSystemID);
    }
    if (entities.length) {
      return entities;
    } else {
      return [];
    }
  }
}
